module.exports = __webpack_public_path__ + "static/media/circular-text.3f8ed695.svg";